/**
 * Helper de diagnóstico de errores.
 * Expone window.__getErrors() en el browser para que usuarios afectados
 * puedan compartir info de errores pasados guardados en sessionStorage.
 */

if (typeof window !== 'undefined') {
    window.__getErrors = () => {
        const errors = {
            lastAppError: null,
            lastUnhandledRejection: null,
            lastGlobalError: null,
            browser: {
                userAgent: navigator.userAgent,
                url: window.location.href,
                timestamp: new Date().toISOString(),
                cookiesEnabled: navigator.cookieEnabled,
                online: navigator.onLine,
                language: navigator.language,
                viewport: `${window.innerWidth}x${window.innerHeight}`,
            },
            localStorage: {},
            sessionStorage: {},
        };

        try {
            errors.lastAppError = JSON.parse(sessionStorage.getItem('lastAppError') || 'null');
        } catch (_) { }
        try {
            errors.lastUnhandledRejection = JSON.parse(sessionStorage.getItem('lastUnhandledRejection') || 'null');
        } catch (_) { }
        try {
            errors.lastGlobalError = JSON.parse(sessionStorage.getItem('lastGlobalError') || 'null');
        } catch (_) { }

        // Listar claves (no valores, por seguridad)
        try {
            errors.localStorage.keys = Object.keys(localStorage);
        } catch (_) { }
        try {
            errors.sessionStorage.keys = Object.keys(sessionStorage);
        } catch (_) { }

        console.log('═══════════════════════════════════════════');
        console.log('📊 DIAGNÓSTICO DE ERRORES');
        console.log('═══════════════════════════════════════════');
        console.log(errors);
        console.log('═══════════════════════════════════════════');
        console.log('Copia este objeto y envíalo a soporte:');
        console.log(JSON.stringify(errors, null, 2));
        console.log('═══════════════════════════════════════════');

        return errors;
    };

    window.__clearErrors = () => {
        try {
            sessionStorage.removeItem('lastAppError');
            sessionStorage.removeItem('lastUnhandledRejection');
            sessionStorage.removeItem('lastGlobalError');
            console.log('Errores limpiados');
        } catch (_) { }
    };
}

export default {};
